import React from "react";

export interface PageErrorViewProps {
  title: string;
  message?: string;
  onRetry?: () => void;
}

/**
 * PageErrorView - Single source of truth for page-level error states.
 * Use when data load fails or a non-recoverable error applies to the whole screen.
 * Title only (e.g. "Error loading facilities"); optional message is not used.
 * Optional onRetry shows a Retry button; callers pass refetch/refresh or window.location.reload.
 */
export const PageErrorView: React.FC<PageErrorViewProps> = ({
  title,
  onRetry,
}) => {
  return (
    <div className="flex justify-center items-center min-h-[60vh]">
      <div className="text-center max-w-md px-4">
        <h2 className="text-lg font-semibold text-red-600 dark:text-red-400 mb-4">
          {title}
        </h2>
        {onRetry && (
          <button
            onClick={onRetry}
            className="bg-brand-600 text-white py-2 px-4 rounded hover:bg-brand-500 dark:bg-brand-500 dark:hover:bg-brand-400"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
};
